import type { FireflyRuntime, ModuleRegisterFunction } from "@squide/firefly";

export const registerPlans: ModuleRegisterFunction<FireflyRuntime> = async runtime => {
    if (runtime.isMswEnabled) {
        const [{ plansRequestHandler }, { planCreationRequestHandlers }] = await Promise.all([import("./mocks/plansRequestHandler.ts"), import("./mocks/assistant/planCreationScript.ts")]);

        runtime.registerRequestHandlers([plansRequestHandler]);
        runtime.registerRequestHandlers(planCreationRequestHandlers, { prepend: true });
    }
};
